import React from 'react';
import { useNavigate } from 'react-router-dom';

import { AddListing, MyListings } from './MyListings.js';
import SoukAkaratAI from './SoukAkaratAI.js';
import Admin from './Admin/Admin.js';

import bottomnavigator_addlisting from './Assets/bottomnavigator/bottomnavigator_addlisting.png';
import bottomnavigator_mylistings from './Assets/bottomnavigator/bottomnavigator_mylistings.png';

import './BottomNavigator.css';

//revision 20240418

function BottomNavigator({ state, setState }) {
  const history = useNavigate();

  const handleAdmin = () => {
    setState(state => ({ ...state, modalopen: true, modalcontent: <Admin state={state} setState={setState} />, modaltype: 'large', modaltitle: 'Admin' }))
  }

  const handleAddListing = () => {
    if (state.user.userid != '') {
      setState(state => ({ ...state, modalopen: true, modalcontent: <AddListing state={state} setState={setState} />, modaltype: 'large', modaltitle: 'Add Listing' }))
    }
    else {
      history('/authscreen');
    }
  }

  const handleMyListings = () => {
    setState(state => ({ ...state, modalopen: true, modalcontent: <MyListings state={state} setState={setState} />, modaltype: 'large', modaltitle: 'My Listings' }))
  }

  const handleAI = () => {
    setState(state => ({ ...state, modalopen: true, modalcontent: <SoukAkaratAI state={state} setState={setState} />, modaltype: 'large', modaltitle: 'Souk Akarat AI' }))
  }

  if (!state.user.userid) {
    return (
      <div className="bottomnavigator">
        <div className="bottomnavigator_section">
        </div>

        <div className="bottomnavigator_section">
          <button className="bottomnavigator_button" onClick={handleAddListing}>
            <img
              className="bottomnavigator_icon"
              src={bottomnavigator_addlisting}
              alt="Add Listing"
            />
          </button>
        </div>

        <div className="bottomnavigator_section">
          <button className="bottomnavigator_button" onClick={handleAI}>
            SOUKAKARAT AI
          </button>
        </div>
      </div>
    );
  }

  if (state.user.usertype == 3) {
    return (
      <div className="bottomnavigator">
        <div className="bottomnavigator_section">
          <button className="bottomnavigator_button" onClick={handleAdmin}>
            Admin
          </button>
        </div>

        <div className="bottomnavigator_section">
        </div>

        <div className="bottomnavigator_section">
          <button className="bottomnavigator_button" onClick={handleAddListing}>
            <img
              className="bottomnavigator_icon"
              src={bottomnavigator_addlisting}
              alt="Add Listing"
            />
          </button>
        </div>

        <div className="bottomnavigator_section">
          <button className="bottomnavigator_button" onClick={handleMyListings}>
            <img
              className="bottomnavigator_icon"
              src={bottomnavigator_mylistings}
              alt="My Listings"
            />
          </button>
        </div>

        <div className="bottomnavigator_section">
          <button className="bottomnavigator_button" onClick={handleAI}>
            Soukakarat AI
          </button>
        </div>
      </div>
    );
  }

  if (state.user.usertype == 2) {
    return (
      <div className="bottomnavigator">
        <div className="bottomnavigator_section">
        </div>

        <div className="bottomnavigator_section">
        </div>

        <div className="bottomnavigator_section">
          <button className="bottomnavigator_button" onClick={handleAddListing}>
            <img
              className="bottomnavigator_icon"
              src={bottomnavigator_addlisting}
              alt="Add Listing"
            />
          </button>
        </div>

        <div className="bottomnavigator_section">
          <button className="bottomnavigator_button" onClick={handleMyListings}>
            <img
              className="bottomnavigator_icon"
              src={bottomnavigator_mylistings}
              alt="My Listings"
            />
          </button>
        </div>

        <div className="bottomnavigator_section">
          <button className="bottomnavigator_button" onClick={handleAI}>
            Soukakarat AI
          </button>
        </div>
      </div>
    );
  }

  return null;
}

export default BottomNavigator;